import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import {
  UpdateUpiDetails,
  DeleteAdminBankdetails,
  getUpiDetails,
} from "../../../Services/Admin/Addmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const Changedpassword = () => {
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  const [bankDetails, setBankDetails] = useState({
    bankname: "",
    ifsc: "",
    accountnumber: "",
    confirmaccountnumber: "",
    accountholdername: "",
    branchname: "",
    walleturl: "",
    qrCodeBase64: "",
    type: "INR",

    bankname1: "",
    ifsc1: "",
    accountnumber1: "",
    confirmaccountnumber1: "",
    accountholdername1: "",
    branchname1: "",
    walleturl1: "",
    qrCodeBase641: "",
    type1: "USD",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const fetchBankDetails = async () => {
    try {
      const res = await getUpiDetails({ id: user_id });
      if (res.status) {
        setBankDetails((prev) => ({
          ...prev,
          ...res.data,
          confirmaccountnumber: res.data?.accountnumber || "",
          confirmaccountnumber1: res.data?.accountnumber1 || "",
        }));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBankDetails();
  }, []);

  const handleBankChange = (e) => {
    const { name, value } = e.target;
    let val = value;

    // Auto-uppercase IFSC codes
    if (name === "ifsc" || name === "ifsc1") {
      val = value.toUpperCase();
    }

    setBankDetails({ ...bankDetails, [name]: val });

    // Clear error message for the field being edited
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Bank Name Validation
    if (!bankDetails.bankname?.trim()) {
      newErrors.bankname = "Bank Name is required";
    } else if (!/^[A-Za-z\s]{3,50}$/.test(bankDetails.bankname)) {
      newErrors.bankname = "Bank Name must be between 3 to 50 letters";
    }

    // Account Holder Name Validation
    if (!bankDetails.accountholdername?.trim()) {
      newErrors.accountholdername = "Account Holder Name is required";
    } else if (!/^[A-Za-z\s]{2,50}$/.test(bankDetails.accountholdername)) {
      newErrors.accountholdername = "Holder Name must be between 2 to 50 letters";
    }

    // Account Number Validation
    if (!bankDetails.accountnumber?.trim()) {
      newErrors.accountnumber = "Account Number is required";
    } else if (!/^\d{9,18}$/.test(bankDetails.accountnumber)) {
      newErrors.accountnumber = "Account Number must be between 9 to 18 digits";
    }

    // Confirm Account Number Validation
    if (!bankDetails.confirmaccountnumber?.trim()) {
      newErrors.confirmaccountnumber = "Please confirm your Account Number";
    } else if (bankDetails.confirmaccountnumber !== bankDetails.accountnumber) {
      newErrors.confirmaccountnumber = "Account Numbers do not match";
    }

    // IFSC Code Validation
    if (!bankDetails.ifsc?.trim()) {
      newErrors.ifsc = "IFSC Code is required";
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(bankDetails.ifsc)) {
      newErrors.ifsc = "Invalid IFSC format";
    }

    // Branch Name Validation
    if (!bankDetails.branchname?.trim()) {
      newErrors.branchname = "Branch Name is required";
    } else if (!/^[A-Za-z0-9\s,.-]{3,50}$/.test(bankDetails.branchname)) {
      newErrors.branchname = "Branch Name must be between 3 to 25 characters";
    }

    // USD Bank Name Validation
    if (!bankDetails.bankname1?.trim()) {
      newErrors.bankname1 = "USD Bank Name is required";
    } else if (!/^[A-Za-z\s]{3,50}$/.test(bankDetails.bankname1)) {
      newErrors.bankname1 = "USD Bank Name must be between 3 to 50 letters";
    }

    // USD Account Holder Name Validation
    if (!bankDetails.accountholdername1?.trim()) {
      newErrors.accountholdername1 = "USD Account Holder Name is required";
    } else if (!/^[A-Za-z\s]{2,50}$/.test(bankDetails.accountholdername1)) {
      newErrors.accountholdername1 = "USD Holder Name must be between 2 to 50 letters";
    }

    // USD Account Number Validation
    if (!bankDetails.accountnumber1?.trim()) {
      newErrors.accountnumber1 = "USD Account Number is required";
    } else if (!/^\d{9,18}$/.test(bankDetails.accountnumber1)) {
      newErrors.accountnumber1 = "USD Account Number must be between 9 to 18 digits";
    }

    // USD Confirm Account Number Validation
    if (!bankDetails.confirmaccountnumber1?.trim()) {
      newErrors.confirmaccountnumber1 = "Please confirm your USD Account Number";
    } else if (bankDetails.confirmaccountnumber1 !== bankDetails.accountnumber1) {
      newErrors.confirmaccountnumber1 = "USD Account Numbers do not match";
    }

    // USD IFSC Code Validation
    if (!bankDetails.ifsc1?.trim()) {
      newErrors.ifsc1 = "USD IFSC Code is required";
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(bankDetails.ifsc1)) {
      newErrors.ifsc1 = "Invalid USD IFSC format";
    }

    // USD Branch Name Validation
    if (!bankDetails.branchname1?.trim()) {
      newErrors.branchname1 = "USD Branch Name is required";
    } else if (!/^[A-Za-z0-9\s,.-]{3,50}$/.test(bankDetails.branchname1)) {
      newErrors.branchname1 = "USD Branch Name must be between 3 to 25 characters";
    }

    // USD Wallet URL Validation
    if (!bankDetails.walleturl1?.trim()) {
      newErrors.walleturl1 = "USD Wallet URL is required";
    }

    setErrors(newErrors);

    const isValid = Object.keys(newErrors).length === 0;
    if (!isValid) {
      const firstErrorField = Object.keys(newErrors)[0];
      if (firstErrorField) {
        const errorElement = document.querySelector(`[name="${firstErrorField}"]`);
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
          errorElement.focus();
        }
      }
    }
    return isValid;
  };

  const handleQRUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setBankDetails((prev) => ({
        ...prev,
        qrCodeBase64: reader.result,
      }));
    };
    reader.readAsDataURL(file);
  };

  const handleQRUpload1 = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setBankDetails((prev) => ({
        ...prev,
        qrCodeBase641: reader.result,
      }));
    };
    reader.readAsDataURL(file);
  };

  const handleBankSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      setSubmitting(true);
      // Remove confirmaccountnumber fields before sending to API
      const { confirmaccountnumber, confirmaccountnumber1, ...submitData } = bankDetails;
      const res = await UpdateUpiDetails({ ...submitData, id: user_id });
      if (res.status) {
        Swal.fire({ icon: "success", title: "Updated", text: res.message });
      }
      fetchBankDetails();
    } catch {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Failed to update bank details",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const DeleteBankDetails = async () => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this action!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = { id: bankDetails._id };
          const response = await DeleteAdminBankdetails(data);
          if (response.status) {
            Swal.fire({
              icon: "success",
              title: response.message,
              text: "Details deleted successfully",
              timer: 5000,
              showConfirmButton: false,
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: response.message,
              text: "",
              timer: 5000,
              showConfirmButton: false,
            });
          }
        }
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Internal Error",
        text: "Something went wrong internally",
      });
    }
  };

  return (
    <div
      className="container-fluid">
      <div className="card transaction-table custom-bg">
        <div className="row justify-content-center">
          <div className="col-xl-12 col-lg-12">
            <div className="card profile-card card-bx shadow-sm border-0 rounded-4">
              {/* CARD HEADER */}
              <div className="card-header d-flex flex-wrap justify-content-between align-items-center border-0 pb-0 pt-3 px-4">
                <div>
                  <h5 className="card-title mb-1">Account Setup</h5>
                  <p className="text-muted small mb-2">
                    Manage your INR and USD wallet details and QR codes.
                  </p>
                </div>
                <div className="mt-2 mt-md-0">
                  <button
                    type="button"
                    className="btn btn-outline-danger "
                    onClick={DeleteBankDetails}
                  >
                    Delete Account
                  </button>
                </div>
              </div>

              <hr className="mt-0 mb-0" />

              {/* CARD BODY */}
              <form className="profile-form" onSubmit={handleBankSubmit}>
                <div className="card-body px-4 pb-3 pt-4">
                  {loading ? (
                    <div className="text-center py-5">
                      <div
                        className="spinner-border"
                        role="status"
                        aria-hidden="true"
                      ></div>
                      <div className="mt-2 text-muted small">
                        Loading wallet details...
                      </div>
                    </div>
                  ) : (
                    <>
                      {/* WALLETS ROW */}
                      <div className="row g-4">
                        {/* INR WALLET */}
                        <div className="col-md-6">
                          <div className="border rounded-3 h-100 p-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6 className="mb-0">INR Wallet</h6>
                              <span className="badge bg-primary">INR</span>
                            </div>
                            <p className="text-muted small mb-3">
                              Add or update your INR wallet UPI and QR code.
                            </p>

                            <div className="row">
                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Bank Name</label>
                                <input
                                  type="text"
                                  name="bankname"
                                  value={bankDetails.bankname}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.bankname ? "is-invalid" : ""
                                    }`}
                                  placeholder="Enter bank name "
                                />
                                {errors.bankname && (
                                  <div className="invalid-feedback">
                                    {errors.bankname}
                                  </div>
                                )}
                              </div>

                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Account Holder Name</label>
                                <input
                                  type="text"
                                  name="accountholdername"
                                  value={bankDetails.accountholdername}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.accountholdername ? "is-invalid" : ""
                                    }`}
                                  placeholder="Enter account holder name"
                                />
                                {errors.accountholdername && (
                                  <div className="invalid-feedback">
                                    {errors.accountholdername}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Account Number</label>
                                <input
                                  type="text"
                                  name="accountnumber"
                                  value={bankDetails.accountnumber}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.accountnumber ? "is-invalid" : ""
                                    }`}
                                  placeholder="Enter account number"
                                />
                                {errors.accountnumber && (
                                  <div className="invalid-feedback">
                                    {errors.accountnumber}
                                  </div>
                                )}
                              </div>

                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Confirm Account Number</label>
                                <input
                                  type="text"
                                  name="confirmaccountnumber"
                                  value={bankDetails.confirmaccountnumber || ""}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.confirmaccountnumber ? "is-invalid" : ""
                                    }`}
                                  placeholder="Confirm account number"
                                />
                                {errors.confirmaccountnumber && (
                                  <div className="invalid-feedback">
                                    {errors.confirmaccountnumber}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-sm-6 mb-3">
                                <label className="form-label">IFSC Code</label>
                                <input
                                  type="text"
                                  name="ifsc"
                                  value={bankDetails.ifsc}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.ifsc ? "is-invalid" : ""
                                    }`}
                                  placeholder="Enter IFSC code"
                                />
                                {errors.ifsc && (
                                  <div className="invalid-feedback">
                                    {errors.ifsc}
                                  </div>
                                )}
                              </div>

                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Branch Name</label>
                                <input
                                  type="text"
                                  name="branchname"
                                  value={bankDetails.branchname}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.branchname ? "is-invalid" : ""
                                    }`}
                                  placeholder="Enter branch name"
                                />
                                {errors.branchname && (
                                  <div className="invalid-feedback">
                                    {errors.branchname}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Wallet URL / UPI ID</label>
                                <input
                                  type="text"
                                  name="walleturl"
                                  value={bankDetails.walleturl}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.walleturl ? "is-invalid" : ""
                                    }`}
                                  placeholder="Enter INR wallet UPI / address"
                                />
                                {errors.walleturl && (
                                  <div className="invalid-feedback">
                                    {errors.walleturl}
                                  </div>
                                )}
                              </div>

                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Upload QR Code</label>
                                <input
                                  type="file"
                                  accept="image/*"
                                  className="form-control"
                                  onChange={handleQRUpload}
                                />
                              </div>
                            </div>

                            {bankDetails.qrCodeBase64 && (
                              <div className="mb-2">
                                <label className="form-label small text-muted">
                                  QR Preview
                                </label>
                                <div className="border rounded p-2 text-center">
                                  <img
                                    src={bankDetails.qrCodeBase64}
                                    alt="INR QR Preview"
                                    className="img-fluid"
                                    style={{
                                      maxHeight: "180px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* USD WALLET */}
                        <div className="col-md-6">
                          <div className="border rounded-3 h-100 p-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6 className="mb-0">USD Wallet</h6>
                              <span className="badge bg-success">USD</span>
                            </div>
                            <p className="text-muted small mb-3">
                              Add or update your USD wallet details and QR code.
                            </p>

                            <div className="row">
                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Bank Name</label>
                                <input
                                  type="text"
                                  name="bankname1"
                                  value={bankDetails.bankname1}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.bankname1 ? "is-invalid" : ""}`}
                                  placeholder="Enter USD bank name"
                                />
                                {errors.bankname1 && (
                                  <div className="invalid-feedback">
                                    {errors.bankname1}
                                  </div>
                                )}
                              </div>

                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Account Holder Name</label>
                                <input
                                  type="text"
                                  name="accountholdername1"
                                  value={bankDetails.accountholdername1}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.accountholdername1 ? "is-invalid" : ""}`}
                                  placeholder="Enter account holder name"
                                />
                                {errors.accountholdername1 && (
                                  <div className="invalid-feedback">
                                    {errors.accountholdername1}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Account Number</label>
                                <input
                                  type="text"
                                  name="accountnumber1"
                                  value={bankDetails.accountnumber1}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.accountnumber1 ? "is-invalid" : ""}`}
                                  placeholder="Enter account number"
                                />
                                {errors.accountnumber1 && (
                                  <div className="invalid-feedback">
                                    {errors.accountnumber1}
                                  </div>
                                )}
                              </div>

                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Confirm Account Number</label>
                                <input
                                  type="text"
                                  name="confirmaccountnumber1"
                                  value={bankDetails.confirmaccountnumber1 || ""}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.confirmaccountnumber1 ? "is-invalid" : ""}`}
                                  placeholder="Confirm account number"
                                />
                                {errors.confirmaccountnumber1 && (
                                  <div className="invalid-feedback">
                                    {errors.confirmaccountnumber1}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-sm-6 mb-3">
                                <label className="form-label">IFSC Code</label>
                                <input
                                  type="text"
                                  name="ifsc1"
                                  value={bankDetails.ifsc1}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.ifsc1 ? "is-invalid" : ""}`}
                                  placeholder="Enter IFSC code"
                                />
                                {errors.ifsc1 && (
                                  <div className="invalid-feedback">
                                    {errors.ifsc1}
                                  </div>
                                )}
                              </div>

                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Branch Name</label>
                                <input
                                  type="text"
                                  name="branchname1"
                                  value={bankDetails.branchname1}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.branchname1 ? "is-invalid" : ""}`}
                                  placeholder="Enter branch name"
                                />
                                {errors.branchname1 && (
                                  <div className="invalid-feedback">
                                    {errors.branchname1}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Wallet URL</label>
                                <input
                                  type="text"
                                  name="walleturl1"
                                  value={bankDetails.walleturl1}
                                  onChange={handleBankChange}
                                  className={`form-control ${errors.walleturl1 ? "is-invalid" : ""}`}
                                  placeholder="Enter USD wallet address"
                                />
                                {errors.walleturl1 && (
                                  <div className="invalid-feedback">
                                    {errors.walleturl1}
                                  </div>
                                )}
                              </div>

                              <div className="col-sm-6 mb-3">
                                <label className="form-label">Upload QR Code</label>
                                <input
                                  type="file"
                                  accept="image/*"
                                  className="form-control"
                                  onChange={handleQRUpload1}
                                />
                              </div>
                            </div>

                            {bankDetails.qrCodeBase641 && (
                              <div className="mb-2">
                                <label className="form-label small text-muted">
                                  QR Preview
                                </label>
                                <div className="border rounded p-2 text-center">
                                  <img
                                    src={bankDetails.qrCodeBase641}
                                    alt="USD QR Preview"
                                    className="img-fluid"
                                    style={{
                                      maxHeight: "180px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* FOOTER */}
                <div className="card-footer bg-white border-0 d-flex justify-content-end px-4 pb-3">
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={submitting || loading}
                  >
                    {submitting ? "Updating..." : "Update Bank Info"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Changedpassword;
